import { BaSeTheme } from '@base/react';
import styled from 'styled-components';

export const BodyInner = styled.div`
  display: flex;
  width: 100%;
  max-width: 1580px;
`;

export const ContentWrapper = styled.div`
  flex: 1;
  position: relative;
  min-width: 0;
  z-index: ${BaSeTheme.stackOrder.normal};
`;

export const MenuSidebar = styled.div`
  width: 260px;
  flex-shrink: 0;
  margin: 1em 1.5em auto auto;
`;

export const MenuDrawerWrapper = styled.div`
  position: absolute;
  left: 0;
  top: 0;
  height: 100%;
`;
